// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.supportTicketForm {
  background: #ffffff;
  box-shadow: 0 2px 10px 1px rgba(105, 105, 105, 0.2);
  border-radius: 12px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
}
.supportTicketForm form {
  width: 100%;
  margin-top: 40px;
}
.supportTicketForm form label {
  color: #2d388b;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 5px;
}
.supportTicketForm form .p-inputtext {
  height: 45px;
  margin-bottom: 20px;
  border-radius: 6px;
}
.supportTicketForm form textarea {
  height: 250px;
  border-color: #ced4da;
  border-radius: 3px;
  margin-bottom: 20px;
}
.supportTicketForm .header-section {
  padding: 32px 32px 0 32px;
}
.supportTicketForm .header-section h2 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 30px;
  letter-spacing: -2px;
  color: #1E38A9;
}
.supportTicketForm .body-section {
  padding: 0px 32px 32px 32px;
}
.supportTicketForm .footer-section {
  border-top: 1px solid #D1D5DB;
  padding: 22px 32px;
}
.supportTicketForm .footer-section .flex {
  margin-left: auto;
}
.supportTicketForm .footer-section .flex .p-button {
  min-width: 236px;
}

.m-10 {
  margin: 10px 0;
}

.p-6 {
  padding: 6px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/colors.scss","webpack://./src/app/add-support-ticket/add-support-ticket.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACCA;EACE,mBAAA;EACA,mDAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAGF;AAFE;EACE,WAAA;EACA,gBAAA;AAIJ;AAHI;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AAKN;AAHI;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;AAKN;AAHI;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAKN;AAFE;EACE,yBAAA;AAIJ;AAHI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,cDXQ;ACgBd;AAFE;EACE,2BAAA;AAIJ;AAFE;EACE,6BAAA;EACA,kBAAA;AAIJ;AAHI;EACE,iBAAA;AAKN;AAJM;EACE,gBAAA;AAMR;;AAAA;EACE,cAAA;AAGF;;AAAA;EACE,uBAAA;AAGF","sourcesContent":["/**\n * Created by Inzamam Janjua on 18/05/2023.\n */\n\n\n// Primary Color Palette\n\n$primaryBlue: #0A6ED9;\n$GreenBlue: #1C75BC;\n$Orange: #EF896A;\n$DarkSilver: #6C6D70;\n$BrightYellow: #F9A51D;\n$Green: #6ACE6A;\n$Greenlight: #7AEC7A;\n$GreenDark: #5CB85C;\n$white: #fff;\n$black: #000;\n$red:#C66A9E;\n// Standard System Colors\n\n$errorRed: #FF3C3C;\n$darkRed: #C11574;\n$lightRed: #FDF2FA;\n$successGreen: #10B981;\n$lightGreen: #ECFAF5;\n$lightOrange: #FFF2EB;\n$notificationYellow: #F9A51D;\n$lightBlue:rgba(226, 238, 255, 1);\n$headingText: #1E38A9;\n","@import \"../../assets/styles/colors.scss\";\n.supportTicketForm{\n  background: #ffffff;\n  box-shadow: 0 2px 10px 1px #69696933;\n  border-radius: 12px;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: auto;\n  form{\n    width: 100%;\n    margin-top: 40px;\n    label{\n      color: #2d388b;\n      font-weight: 500;\n      display: inline-block;\n      margin-bottom: 5px;\n    }\n    .p-inputtext{\n      height: 45px;\n      margin-bottom: 20px;\n      border-radius: 6px;\n    }\n    textarea {\n      height: 250px;\n      border-color: #ced4da;\n      border-radius: 3px;\n      margin-bottom: 20px;\n    }\n  }\n  .header-section{\n    padding: 32px 32px 0 32px;\n    h2{\n      font-style: normal;\n      font-weight: 600;\n      font-size: 40px;\n      line-height: 30px;\n      letter-spacing: -2px;\n      color: $headingText;\n    }\n  }\n  .body-section{\n    padding: 0px 32px 32px 32px;\n  }\n  .footer-section{\n    border-top: 1px solid #D1D5DB;\n    padding: 22px 32px;\n    .flex{\n      margin-left: auto;\n      .p-button{\n        min-width: 236px;\n      }\n    }\n  }\n}\n\n.m-10 {\n  margin: 10px 0;\n}\n\n.p-6 {\n  padding: 6px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
